<template lang="pug">
el-input.phone-input(
  :model-value="modelValue",
  :placeholder="$t('phoneNumber')",
  type="tel",
  pattern="^\\+?[0-9]{7,30}$",
  maxlength="31",
  inputmode="tel",
  :id="id",
  :aria-describedby="ariaDescribedby",
  :aria-invalid="ariaInvalid",
  :aria-required="ariaRequired",
  :disabled="disabled",
  @update:model-value="sanitizeInput"
)
</template>

<script lang="ts" setup>
defineProps<{
  modelValue?: string;
  id?: string;
  ariaDescribedby?: string;
  ariaInvalid?: boolean;
  ariaRequired?: boolean;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  "update:modelValue": [value: string];
}>();

function sanitizeInput(value: string | number): void {
  // Only allow digits and + (only at the beginning)
  const sanitized = String(value)
    .replace(/[^\d+]/g, "")
    .replace(/\+/g, (match, offset) => (offset === 0 ? "+" : ""));

  emit("update:modelValue", sanitized);
}
</script>
